<template>
  <app-modal name="invoice-preview-modal" @before-open="beforeOpen" width="60%" :hide-footer-button="true">
    <div :style="{ height: `${height}px` }" v-if="pdfURL">
      <iframe v-if="!isLoading" width="100%" :src="pdfURL" :height="height" />
    </div>
    <template v-slot:title>
      <invoice-view-title default-title="Xem trước hóa đơn" :is-loading="isLoading"
        :changed-invoice-data="changedInvoiceData" @on-click-invoice-number="handleClickInvoiceNumber" />
    </template>
    <template v-slot:control>
      <div class="d-flex justify-content-between align-items-center w-full">
        <div class="d-flex">
          <button :disabled="isLoading" class="btn btn-outline-primary btn-sm" @click="handleSendEmail">
            <i v-if="isLoading" class="fa fa-spinner-third fa-spin" aria-hidden="true"></i>
            <i v-else class="fa fa-paper-plane" aria-hidden="true"></i>
            {{ $t('actions.form.actions.send') }}
          </button>
        </div>

        <div class="d-flex">
          <button class="btn btn-primary btn-sm mr-3" @click="handleDownloadPDF">
            <i class="fa fa-download" aria-hidden="true"></i>
            Tải PDF
          </button>
          <button class="btn btn-primary btn-sm mr-3" @click="handlePrintPDF">
            <i class="fa fa-print" aria-hidden="true"></i>
            In PDF
          </button>
        </div>
      </div>
    </template>
  </app-modal>
</template>
<script>
import ToastUtils from '@/utils/toast';
import { DOWNLOAD_URL } from '@/app-constant';
import AppModal from '@/components/app-modal/';
import { EInvoiceProxy } from '@/store/proxies/e-invoice';
import InvoiceViewTitle from './invoice-view-title.vue';

export default {
  name: 'InvoicePreviewModal',
  components: { InvoiceViewTitle, AppModal },
  data() {
    return {
      invoiceId: null,
      invoiceCommonCode: null,
      changedInvoiceData: null,

      height: window.innerHeight,
      pdfURL: null,
      zipURL: '',
      xmlURL: '',
      buyerInfo: {},
      mailHistories: '',

      isLoading: false,
    };
  },
  methods: {
    beforeOpen(params) {
      const {
        pdfURL,
        zipURL,
        xmlURL,
        buyerInfo,
        mailHistories,

        invoiceId,
        invoiceCommonCode,
        changedInvoiceData,
      } = params;
      this.height = window.innerHeight;

      this.pdfURL = pdfURL;
      this.zipURL = zipURL;
      this.xmlURL = xmlURL;
      this.buyerInfo = buyerInfo;
      this.mailHistories = mailHistories;

      this.invoiceId = invoiceId;
      this.invoiceCommonCode = invoiceCommonCode;
      this.changedInvoiceData = changedInvoiceData;
    },
    handleDownloadPDF($event) {
      $event.preventDefault();
      $event.stopPropagation();
      const urlExport = DOWNLOAD_URL + encodeURIComponent(this.pdfURL);
      window.open(urlExport, '_blank');
    },
    handlePrintPDF($event) {
      $event.preventDefault();
      $event.stopPropagation();
      window.open(this.pdfURL, '_blank');
    },
    handleSendEmail($event) {
      $event.preventDefault();
      $event.stopPropagation();
      if (!this.buyerInfo) {
        ToastUtils.showToast('error', 'Lỗi lấy dữ liệu');
        return;
      }
      this.$modal.show('send-email-modal', {
        filePath: this.pdfURL,
        model: this.buyerInfo,
        invoiceId: this.invoiceId,
        mailHistories: this.mailHistories,
        invoiceCommonCode: this.invoiceCommonCode,
      });
    },
    handleClickInvoiceNumber(props) {
      const { pinvoiceId } = props;
      this.invoiceId = pinvoiceId;
      this.isLoading = true;
      new EInvoiceProxy().getEInvoice(pinvoiceId)
        .then((res) => {
          if (res) {
            this.mailHistories = res.mail_histories;
            this.invoiceCommonCode = res.invoice_common_code;
            this.buyerInfo = res.buyer_obj;

            this.pdfURL = res.signed_pdf;
            this.xmlURL = res.signed_xml;
            this.zipURL = res.zip_resource_url;

            this.changedInvoiceData = {
              changeInvoices: res.change_invoices_fk,
              changedInvoice: res.changed_invoice_fk,
              currentInvoice: {
                status: res.status,
                invoice_number: res.invoice_number,
              },
            };
          }
        }).finally(() => { this.isLoading = false; });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-preview-modal.vue